import {REPORT_TEAMS_FIBL} from '/enum/records.enum';

export default {
  reportName: REPORT_TEAMS_FIBL,
};
